import React from 'react';

const SvgIconTenancy = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path d="M15.36 3.348h-1.393v-.564a.66.66 0 10-1.321 0v.564H7.358v-.564a.66.66 0 10-1.322 0v.564H4.64c-1.093 0-1.982.89-1.982 1.983v10.556c0 1.093.89 1.983 1.982 1.983h10.721c1.094 0 1.983-.89 1.983-1.983V5.33a1.988 1.988 0 00-1.984-1.983zM4.64 4.67h1.396v.84a.66.66 0 101.322 0v-.84h5.288v.84a.66.66 0 101.321 0v-.84h1.393c.363 0 .66.297.66.661V6.88H3.98V5.33a.66.66 0 01.66-.66zm10.72 11.878H4.64a.662.662 0 01-.66-.661V8.204h12.042v7.685a.664.664 0 01-.662.659zm-1.577-6.789H5.85a.66.66 0 100 1.322h7.933a.66.66 0 100-1.322zm0 3.201H5.85a.66.66 0 100 1.322h7.933a.66.66 0 100-1.322z" />
  </svg>
);

export default SvgIconTenancy;
